import { EventWithdraw } from './EventWithdraw';

export default EventWithdraw;
